import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const AssetLocationImportTDAs = gql`
    query AssetLocationImportTDAs ($id: ID!) {
        assetLocation (id: $id) {
            id
            installedBaseNode {
                id
                title
            }
            asset {
                id
                assetLocationImport {
                    id
                    typeDefinitionAttributeList {
                        typeDefinitionAttributes {
                            ...TypeDefinitionAttributeFields
                        }
                    }
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
